import React from 'react'
import styled from 'styled-components'

import { P } from '../CommonStyle'

const MrktAlertWrap = styled.div`
    background-color: #D4FFDE;
    width: 95%;
    height: 56px;
    position: fixed;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 40px;
    z-index: 100;
    box-shadow: 0px 30px 60px rgba(69, 69, 69, 0.25);
    left: 50%;
    top: 5%;
    transform: translate(-52%, -50%);

    @media screen and (max-width: 767px) {
      left: 45%;
      width: 90% !important;
    }
`
const AlertTxt = styled.div``


export default function Success(props) {
  return (
    <div>
        <MrktAlertWrap>
            <AlertTxt>
                <P text={props.message} color="#1F936E" fontSize="18px" fontWeight="bold" cursor="auto"></P>
            </AlertTxt>
        </MrktAlertWrap>
    </div>
  )
}




